module.exports = __webpack_public_path__ + "img/tg.aa48be3.svg";